import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-time-estimate-modal',
    templateUrl: './time-estimate-modal.component.html',
    styleUrls: ['./time-estimate-modal.component.scss'],
    standalone: false
})
export class TimeEstimateModalComponent {
  private modalController = inject(ModalController);


  close() {
    this.modalController.dismiss();
  }
}
